module.exports = __webpack_public_path__ + "img/14.240275b3.svg";